import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import Swal from "sweetalert2";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { FaArrowLeft } from "react-icons/fa";
import { useSelector } from "react-redux";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 30px;
`;

const Center = styled.div`
  flex: 1;
  display: inline;
  text-align: center;
`;

const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
  margin-top: 20px;
`;

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`;
const Div = styled.div``;
const Label = styled.label``;
const Input = styled.input`
  width: 100%;
`;
const Span = styled.span`
  color: red;
`;
const Textarea = styled.textarea``;

const Select = styled.select`
  padding: 5px 7px;
  border-radius: 5px;
`;
const Option = styled.option``;

const Table = styled.table``;
const Thead = styled.thead``;
const Tbody = styled.tbody``;
const Tr = styled.tr`
  text-align: center;
`;
const Th = styled.th`
  font-size: 15px;
`;
const Td = styled.td`
  font-size: 14px;
`;

const Create = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const navigate = useNavigate();
  const api = apiInstance;

  const Id = useLocation().pathname.split("/")[2];
  const Name = localStorage.getItem("Name");
  // console.log(Name, "name");
  const [doctors, setDoctors] = useState([]);

  const [therapists, setTherapists] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [expDate, setExpDate] = useState("");
  const [alertDate, setAlertDate] = useState("");
  const [accessories, setAccessories] = useState([]);
  const [medicineList, setMedicineList] = useState([]);
  const [isItem, setIsItem] = useState(false);

  const [isAccItem, setIsAccItem] = useState(false);
  const [isGenItem, setIsGenItem] = useState(false);
  const [generalList, setGeneralList] = useState([]);
  const [isMedItem, setIsMedItem] = useState(false);
  const [proTran, setProTran] = useState("");
  const [medTran, setMedTran] = useState("");
  const [accTran, setAccTran] = useState("");

  const [upProData, setUpProData] = useState([]);
  const [upMedData, setUpMedData] = useState([]);
  const [upProAcc, setUpProAcc] = useState([]);
  const [upGen, setUpGen] = useState([]);
  const [seq, setSeq] = useState("");
  const [upBranchID, setUpBranchID] = useState("");
  const [upBranchName, setUpBranchName] = useState("");

  const [branchID, setBranchID] = useState("");
  const [branchLists, setBranchLists] = useState([]);

  const [date, setDate] = useState("");
  const [name, setName] = useState("");

  const [stockReqData, setStockReqData] = useState([]);

  //Medicine
  const [tableProAccData, setTableProAccData] = useState([]);
  const [genTran, setGenTran] = useState("");

  //General
  const [tableGenData, setTableGenData] = useState([]);
  const [selectGenOption, setSelectGenOption] = useState({
    id: "",
    name: "",
  });

  const StockReqID = useLocation().pathname.split("/")[2];
  const [code, setCode] = useState("");

  // const handleMedErrorInputChange = event => {
  //   console.log(event.split('.')[0], 'pro event')
  // }
  useEffect(() => {
    const getCode = async () => {
      const res = await api.get("stock-transfers/code");
      // console.log(res.data.data, "data seq");
      setCode(res.data.data.patientID);
      setSeq(res.data.data.seq);
      // console.log(res.data.data.patientID, "code");
    };

    const getDoctors = async () => {
      const res = await api.get("doctors");
      setDoctors(res.data.data);
    };
    const getTherapists = async () => {
      const res = await api.get("therapists");
      setTherapists(res.data.data);
    };
    const getMedicine = async () => {
      const res = await api.get("medicine-items");
      setMedicineList(res.data.list);
    };

    const getProcedures = async () => {
      const res = await api.get("procedure-items");
      setProcedures(res.data.list);
    };
    const getAccessories = async () => {
      const res = await api.get("accessory-items");
      // console.log(res.data.list);
      setAccessories(res.data.list);
    };
    const getGeneral = async () => {
      const res = await api.get("general-items");
      // console.log(res.data.list);
      setGeneralList(res.data.list);
    };
    const getBranch = async () => {
      const res = await api.get("branches");
      // console.log(res.data.list);
      setBranchID(res.data.list[0]._id);
      setBranchLists(res.data.list);
    };

    const getStockReqList = async () => {
      try {
        const res = await api.get("stock-request/" + StockReqID);
        // console.log(res.data.data[0], "Req");
        setStockReqData(res.data.data[0]);
        setUpBranchID(res.data.data[0].relatedBranch._id);
        setUpBranchName(res.data.data[0].relatedBranch.name);

        //NOTE For Medicine
        if (
          res.data.data[0].medicineLists !== null &&
          res.data.data[0].medicineLists.length > 0
        ) {
          const newData = res.data.data[0].medicineLists.map((data, index) => {
            return {
              id: index,
              name: data.item_id ? data.item_id.medicineItemName : "",
              item_id: data.item_id,
              stockQty: data.item_id.currentQuantity,
              requestedQty: data.requestedQty,
              purchasePrice: data.purchasePrice,
            };
          });
          setUpMedData(newData);
          // console.log(newData, "dat");
          // console.log(newData.map(i => i.stockQty)[0] === 0, 'w')

          setIsMedItem(true);
        }
        //NOTE For Procedure Medicine
        if (
          res.data.data[0].procedureMedicine !== null &&
          res.data.data[0].procedureMedicine.length > 0
        ) {
          const newData = res.data.data[0].procedureMedicine.map(
            (data, index) => {
              return {
                id: index,
                name: data.item_id ? data.item_id.procedureItemName : "",
                item_id: data.item_id,
                stockQty: data.item_id.currentQuantity,
                requestedQty: data.requestedQty,
                purchasePrice: data.purchasePrice,
              };
            },
          );
          setUpProData(newData);
          // setProReq(newData.requestedQty)

          setIsItem(true);
        }
        //NOTE For Procedure Accessory
        if (
          res.data.data[0].procedureAccessory !== null &&
          res.data.data[0].procedureAccessory.length > 0
        ) {
          const newData = res.data.data[0].procedureAccessory.map(
            (data, index) => {
              return {
                id: index,
                name: data.item_id ? data.item_id.accessoryItemName : "",
                item_id: data.item_id,
                stockQty: data.item_id.currentQuantity,
                requestedQty: data.requestedQty,
                purchasePrice: data.purchasePrice,
              };
            },
          );
          setUpProAcc(newData);

          // console.log(newData, "Pro Acc");
          setIsAccItem(true);
        }

        //NOTE For General
        if (
          res.data.data[0].generalItems !== null &&
          res.data.data[0].generalItems.length > 0
        ) {
          const newData = res.data.data[0].generalItems.map((data, index) => {
            return {
              id: index,
              name: data.item_id ? data.item_id.generalItemName : "",
              item_id: data.item_id,
              stockQty: data.item_id.currentQuantity,
              requestedQty: data.requestedQty,
              purchasePrice: data.purchasePrice,
            };
          });
          setUpGen(newData);

          // console.log(newData, "Gen");
          setIsGenItem(true);
        }
      } catch (err) {}
    };

    getStockReqList();
    getMedicine();
    getDoctors();
    getTherapists();
    getProcedures();
    getAccessories();
    getBranch();
    getGeneral();
    getCode();
  }, []);

  //Start procedure medicine add row

  //NOTE Input Changes when input qty and per usage qty
  const handleProInputChange = (event, id, field) => {
    const value = event.target.value;
    // console.log(field, "pro fi");
    const newData = upProData.map((data) => {
      if (data.id === id) {
        if (field === "transferQty") {
          const qty = Math.max(0, Number(value) || 0);
          return {
            ...data,
            transferQty: data.item_id?.currentQuantity === 0 ? 0 : qty,
            totalPrice: qty * Number(data.item_id.purchasePrice || 0),
          };
        }
        if (field === "expDate") {
          return { ...data, expiredDate: value };
        }
        if (field === "alertDate") {
          return { ...data, alertDate: value };
        }
      }
      return data;
    });
    // console.log(newData, "Pro Data inp");
    // setProTran(newData[0]?.transferQty);
    // console.log(upProData, 'tran valu')

    setUpProData(newData);
  };

  //NOTE to delete proecedure medicine
  const removeProcedure = (index) => {
    setUpProData(upProData.filter((el, ind) => ind !== index));
  };
  //End procedure medicine add row

  //Start Medicine add row
  //NOTE Input Changes when input qty and per usage qty

  const handleMedInputChange = (event, id, field) => {
    // setMedID(id, "med tran");
    // console.log(event, 'med tran')
    const value = event.target.value;

    const newData = upMedData.map((data) => {
      if (data.id === id) {
        if (field === "transferQty") {
          const qty = Math.max(0, Number(value) || 0);
          return {
            ...data,
            transferQty: data.item_id?.currentQuantity === 0 ? 0 : qty,
            totalPrice: qty * Number(data.item_id.purchasePrice || 0),
          };
        }
        if (field === "expDate") {
          return { ...data, expiredDate: value };
        }
        if (field === "alertDate") {
          return { ...data, alertDate: value };
        }
      }
      return data;
    });

    // setMedTran(newData[0]?.transferQty);

    // setUpMedData([...newData]);
    setUpMedData(newData);
  };

  //NOTE to delete proecedure medicine
  const removeMedicine = (index) => {
    setUpMedData(upMedData.filter((el, ind) => ind !== index));
  };

  //End Medicine add row

  //Start ProAccessory add row
  //NOTE Input Changes when input qty and per usage qty
  const handleProAccInputChange = (event, id, field) => {
    const value = event.target.value;
    const newData = upProAcc.map((data) => {
      if (data.id === id) {
        if (field === "transferQty") {
          const qty = Math.max(0, Number(value) || 0);
          return {
            ...data,
            transferQty: data.item_id?.currentQuantity === 0 ? 0 : qty,
            totalPrice: qty * Number(data.item_id.purchasePrice || 0),
          };
        }
        if (field === "expDate") {
          return { ...data, expiredDate: value };
        }
        if (field === "alertDate") {
          return { ...data, alertDate: value };
        }
        // return {
        //   ...data,
        //   totalPrice:
        //     parseInt(event.target.value) * data.item_id.purchasePrice || 0,
        //   transferQty:
        //     data.item_id?.currentQuantity === 0
        //       ? 0
        //       : parseInt(event.target.value),
        //   expiredDate: expDate,
        //   alertDate: alertDate,
        // };
      }
      return data;
    });
    // console.log(newData);
    // setAccTran(newData[0]?.transferQty);

    setUpProAcc(newData);
  };

  //NOTE to delete proecedure medicine
  const removeProAcc = (index) => {
    setTableProAccData(tableProAccData.filter((el, ind) => ind !== index));
  };

  const handleGenInputChange = (event, id, field) => {
    const value = event.target.value;
    const newData = upGen.map((data) => {
      if (data.id === id) {
        if (field === "transferQty") {
          const qty = Math.max(0, Number(value) || 0);
          return {
            ...data,
            transferQty: data.item_id?.currentQuantity === 0 ? 0 : qty,
            totalPrice: qty * Number(data.item_id.purchasePrice || 0),
          };
        }
        if (field === "expDate") {
          return { ...data, expiredDate: value };
        }
        if (field === "alertDate") {
          return { ...data, alertDate: value };
        }
        // return {
        //   ...data,
        //   totalPrice:
        //     parseInt(event.target.value) * data.item_id.purchasePrice || 0,
        //   transferQty:
        //     data.item_id?.currentQuantity === 0
        //       ? 0
        //       : parseInt(event.target.value),
        //   expiredDate: expDate,
        //   alertDate: alertDate,
        // };
      }
      return data;
    });
    // console.log(newData);
    setGenTran(newData[0]?.transferQty);

    setUpGen(newData);
  };

  //NOTE to delete proecedure medicine
  const removeGen = (index) => {
    setTableGenData(tableGenData.filter((el, ind) => ind !== index));
  };

  //End Medicine add row
  // console.log(upMedData[0] ? upMedData[0].requestedQty : '', 'ori pro req')
  // console.log(upMedData[0] ? upProData[0].requestedQty : '', 'ori pro req')
  // console.log(upMedData[0] ? upProAcc[0].requestedQty : '', 'ori pro req')

  //End add table row and delete
  // console.log(upMedData[0].requestedQty, 'med data')

  const submit = (id) => {
    confirmAlert({
      title: "Transfer Create?",
      message: "Are you fill TransferQty = 0 <or> Greater than RequestQty?",
      buttons: [
        {
          label: "Yes",
          onClick: () => create(),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const create = () => {
    if (
      upMedData.filter(
        (i) => i.transferQty <= i.stockQty && i.transferQty <= i.requestedQty,
      )[0] ||
      upProData.filter(
        (i) => i.transferQty <= i.stockQty && i.transferQty <= i.requestedQty,
      )[0] ||
      upProAcc.filter(
        (i) => i.transferQty <= i.stockQty && i.transferQty <= i.requestedQty,
      )[0] ||
      upGen.filter(
        (i) => i.transferQty <= i.stockQty && i.transferQty <= i.requestedQty,
      )[0]
    ) {
      const data = {
        date: date,
        stockRequestID: StockReqID,
        // relatedBranch: branchID,
        requestNo: code,
        requestedBy: Name,
        transferNo: stockReqData.requestNo,
        transferBy: stockReqData.requestedBy,
        medicineLists: upMedData,
        procedureMedicine: upProData,
        procedureAccessory: upProAcc,
        generalItems: upGen,
        status: true,
        seq: seq,
        relatedBranch: upBranchID,
      };

      // alert(JSON.stringify(data));
      // if (upBranchID) {
      //   data.relatedBranch = upBranchID;
      // }

      api
        .post("stock-transfer", data)
        .then(function (response) {
          Swal.fire({
            title: "Successful!",
            text: "Successfully Created",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          navigate("/stock-req");
        })
        .catch(function (err) {
          Swal.fire({
            title: "Something Wrong!",
            text: "Try again, Please.",
            icon: "warning",
            showConfirmButton: false,
            timer: 2000,
          });
          console.log(err, "err");
        });
    } else {
      Swal.fire({
        title: "Check Your Transfer Qty!",
        text: "Try again, Please.",
        icon: "warning",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const medCheck = medTran > upMedData[0] ? upMedData[0].requestedQty : "";

  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/stock-req">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Stock Transfer Create
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="card-body row border border-dark">
                <h5>Create</h5>
                <div className="ml-5 col-8 py-5">
                  <div className="row">
                    <div className="col-6 form-group ">
                      <Label>
                        Date<Span>*</Span>
                      </Label>
                      <Input
                        type="date"
                        className="form-control"
                        onChange={(e) => setDate(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>

                    <div className="col-md-6 mt-1">
                      <div class="form-group">
                        <label for="name">Branches</label>
                        <select
                          class="custom-select border-info"
                          name="account_type_id"
                          id="cat"
                          style={{ borderRadius: "15px" }}
                        >
                          <option value={upBranchID}>{upBranchName}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 form-group ">
                      <Label>
                        Request No:<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        disabled
                        value={stockReqData?.requestNo}
                        // onChange={(e) => setCode(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                    <div className="col-6 form-group">
                      <Label>
                        Request By:<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        disabled
                        value={stockReqData?.requestedBy}
                        // onChange={(e) => setName(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 form-group ">
                      <Label>
                        Transfer No:<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                    <div className="col-6 form-group">
                      <Label>
                        Issued By:<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        value={Name}
                        onChange={(e) => setName(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 mt-3">
                      <h5>Medicine</h5>

                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>

                            <Th>Stock Qty</Th>

                            <Th>Req Qty</Th>
                            <th>Purchase Price</th>
                            <Th>Transfer Qty</Th>
                            <Th>Total</Th>
                            <Th>Unit</Th>
                            <Th>Expired Date</Th>
                            <Th>Alert Date</Th>
                          </Tr>
                        </Thead>
                        {isMedItem && (
                          <Tbody>
                            {upMedData &&
                              upMedData.map((item, index) => (
                                <Tr>
                                  <Td>{++index}</Td>
                                  {item.item_id?.currentQuantity === 0 ? (
                                    <Td>
                                      <b className="text-red">{item.name}</b>
                                    </Td>
                                  ) : (
                                    <Td>{item.name}</Td>
                                  )}
                                  {item.item_id?.currentQuantity === 0 ? (
                                    <Td>
                                      <b className="text-red">
                                        {item.item_id.currentQuantity}
                                      </b>
                                    </Td>
                                  ) : (
                                    <Td>{item.item_id.currentQuantity}</Td>
                                  )}
                                  {/* <Td>{procedure.purchasePrice}</Td> */}
                                  <Td>{item.requestedQty}</Td>
                                  <Td>{item.item_id.purchasePrice}</Td>
                                  <Td>
                                    {/* {console.log(item.transferQty, 'tran qty')} */}
                                    {item.transferQty > item.requestedQty ||
                                    item.item_id?.currentQuantity === 0 ||
                                    item.item_id?.currentQuantity <
                                      item.transferQty ? (
                                      <>
                                        <input
                                          type="number"
                                          defaultValue={item.transferQty}
                                          style={{
                                            borderRadius: "10px",
                                            border: "2px solid red",
                                            width: "150px",
                                          }}
                                          className="text-center form-control"
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(event) =>
                                            handleMedInputChange(
                                              event,
                                              item.id,
                                              "transferQty",
                                            )
                                          }
                                        />
                                        {item.item_id?.currentQuantity === 0 ? (
                                          <p style={{ color: "red" }}>
                                            Reorder items or Fill only '0'
                                          </p>
                                        ) : item.item_id?.currentQuantity <
                                          item.transferQty ? (
                                          <p style={{ color: "red" }}>
                                            Transfer Qty must have less than
                                            Stock Qty!
                                          </p>
                                        ) : (
                                          <p style={{ color: "red" }}>
                                            Requested Qty must have less than
                                            equal Stock Qty!
                                          </p>
                                        )}
                                      </>
                                    ) : (
                                      <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        defaultValue={item.transferQty}
                                        style={{
                                          borderRadius: "10px",
                                          width: "150px",
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        className="text-center form-control"
                                        onChange={(event) =>
                                          handleMedInputChange(
                                            event,
                                            item.id,
                                            "transferQty",
                                          )
                                        }
                                      />
                                    )}
                                    {/* <input
                                      type='number'
                                      defaultValue={item.transferQty}
                                      style={{ borderRadius: '10px' }}
                                      className='text-center'
                                      onChange={event =>
                                        handleMedInputChange(
                                          event,
                                          item.id,
                                          'transferQty'
                                        )
                                      }
                                      className='text-center'
                                    /> */}
                                  </Td>
                                  <Td>
                                    <input
                                      type="number"
                                      value={
                                        item?.transferQty *
                                        item.item_id?.purchasePrice
                                      }
                                      style={{
                                        borderRadius: "10px",
                                        width: "150px",
                                      }}
                                      className="text-center form-control"
                                      disabled
                                    />
                                  </Td>
                                  <Td>{item.item_id?.unit}</Td>
                                  <Td>
                                    <input
                                      type="date"
                                      style={{ borderRadius: "10px" }}
                                      className="text-center form-control"
                                      onChange={(event) =>
                                        handleMedInputChange(
                                          event,
                                          item.id,
                                          "expDate",
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td>
                                    <input
                                      type="date"
                                      style={{ borderRadius: "10px" }}
                                      className="text-center form-control"
                                      onChange={(event) =>
                                        handleMedInputChange(
                                          event,
                                          item.id,
                                          "alertDate",
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td>
                                    <RxCross2
                                      onClick={() => removeMedicine(index)}
                                    />
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    {/* NOTE Procedure Medicine */}

                    <div className="col-12 mt-4">
                      <h5>Procedure Medicine</h5>

                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Stock Qty</Th>
                            <Th>Req Qty</Th>
                            <Th>Purchase Price</Th>
                            <Th>Transfer Qty</Th>
                            <Th>Total</Th>
                            <Th>Unit</Th>
                            <Th>Expired Date</Th>
                            <Th>Alert Date</Th>
                          </Tr>
                        </Thead>
                        {isItem && (
                          <Tbody>
                            {upProData &&
                              upProData.map((item, index) => (
                                <Tr>
                                  <Td>{++index}</Td>
                                  {item.item_id?.currentQuantity === 0 ? (
                                    <Td>
                                      <b className="text-red">{item.name}</b>
                                    </Td>
                                  ) : (
                                    <Td>{item.name}</Td>
                                  )}
                                  {item.item_id?.currentQuantity === 0 ? (
                                    <Td>
                                      <b className="text-red">
                                        {item.item_id.currentQuantity}
                                      </b>
                                    </Td>
                                  ) : (
                                    <Td>{item.item_id.currentQuantity}</Td>
                                  )}
                                  <Td>{item.requestedQty}</Td>
                                  <Td>{item.item_id.purchasePrice}</Td>

                                  <Td>
                                    {item.transferQty > item.requestedQty ||
                                    item.item_id?.currentQuantity === 0 ||
                                    item.item_id?.currentQuantity <
                                      item.transferQty ? (
                                      <>
                                        <input
                                          type="number"
                                          defaultValue={item.transferQty}
                                          style={{
                                            borderRadius: "10px",
                                            border: "2px solid red",
                                            width: "150px",
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                          className="text-center form-control"
                                          onChange={(event) =>
                                            handleProInputChange(
                                              event,
                                              item.id,
                                              "transferQty",
                                            )
                                          }
                                        />
                                        {item.item_id?.currentQuantity === 0 ? (
                                          <p style={{ color: "red" }}>
                                            Reorder items or Fill only '0'
                                          </p>
                                        ) : item.item_id?.currentQuantity <
                                          item.transferQty ? (
                                          <p style={{ color: "red" }}>
                                            Transfer Qty must have less than
                                            Stock Qty!
                                          </p>
                                        ) : (
                                          <p style={{ color: "red" }}>
                                            Requested Qty must have less than
                                            equal Stock Qty!
                                          </p>
                                        )}
                                      </>
                                    ) : (
                                      <input
                                        type="number"
                                        defaultValue={item.transferQty}
                                        style={{
                                          borderRadius: "10px",
                                          width: "150px",
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        className="text-center form-control"
                                        onChange={(event) =>
                                          handleProInputChange(
                                            event,
                                            item.id,
                                            "transferQty",
                                          )
                                        }
                                      />
                                    )}
                                  </Td>
                                  <Td>
                                    <input
                                      type="number"
                                      value={
                                        item?.transferQty *
                                        item.item_id?.purchasePrice
                                      }
                                      style={{
                                        borderRadius: "10px",
                                        width: "120px",
                                      }}
                                      className="text-center form-control"
                                      disabled
                                    />
                                  </Td>
                                  <Td>{item.item_id?.unit}</Td>
                                  <Td>
                                    <input
                                      type="date"
                                      style={{
                                        borderRadius: "10px",
                                        border: "1px solid gray",
                                      }}
                                      className="text-center form-control"
                                      onChange={(event) =>
                                        handleProInputChange(
                                          event,
                                          item.id,
                                          "expDate",
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td>
                                    <input
                                      type="date"
                                      style={{ borderRadius: "10px" }}
                                      className="text-center form-control"
                                      onChange={(event) =>
                                        handleProInputChange(
                                          event,
                                          item.id,
                                          "alertDate",
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td>
                                    <RxCross2
                                      onClick={() => removeProcedure(index)}
                                    />
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>
                    {/* NOTE End Procedure Medicine */}

                    {/* <div className='row'>
                      <div className='col-6 form-group mt-3'>
                        <Label>Procedure Accessory</Label>
                        <Select
                          className='form-control'
                          onChange={handleProAccGet}
                          style={{ borderRadius: '15px' }}
                        >
                          <Option>Select Procedure Accessory</Option>
                          {accessories.map((accessory, index) => (
                            <Option
                              value={accessory._id}
                              data-id={accessory._id}
                              data-name={accessory.accessoryItemName}
                            >
                              {accessory.accessoryItemName}
                            </Option>
                          ))}
                        </Select>
                      </div>
                      <div className='col-3 mt-4'>
                        <Button
                          style={{
                            backgroundColor: 'pink',
                            marginTop: '1.5em'
                          }}
                          onClick={e =>
                            handleProAccAddRow(
                              selectProAccOption.id,
                              selectProAccOption.name
                            )
                          }
                        >
                          Add
                        </Button>
                      </div>
                    </div> */}
                    <div className="col-12 mt-3">
                      <h5>Procedure Accessory</h5>
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>

                            <Th>Stock Qty</Th>

                            <Th>Req Qty</Th>
                            <Th>Purchase Price</Th>
                            <Th>Transfer Qty</Th>
                            <Th>Total</Th>
                            <Th>Unit</Th>
                            <Th>Expired Date</Th>
                            <Th>Alert Date</Th>
                          </Tr>
                        </Thead>
                        {isAccItem && (
                          <Tbody>
                            {upProAcc &&
                              upProAcc.map((item, index) => (
                                <Tr>
                                  <Td>{++index}</Td>
                                  {item.item_id?.currentQuantity === 0 ? (
                                    <Td>
                                      <b className="text-red">{item.name}</b>
                                    </Td>
                                  ) : (
                                    <Td>{item.name}</Td>
                                  )}
                                  {item.item_id?.currentQuantity === 0 ? (
                                    <Td>
                                      <b className="text-red">
                                        {item.item_id.currentQuantity}
                                      </b>
                                    </Td>
                                  ) : (
                                    <Td>{item.item_id.currentQuantity}</Td>
                                  )}
                                  {/* <Td>{procedure.purchasePrice}</Td> */}
                                  <Td>{item.requestedQty}</Td>
                                  <Td>{item.item_id?.purchasePrice}</Td>

                                  <Td>
                                    {item.transferQty > item.requestedQty ||
                                    item.item_id?.currentQuantity === 0 ||
                                    item.item_id?.currentQuantity <
                                      item.transferQty ? (
                                      <>
                                        <input
                                          type="number"
                                          defaultValue={item.transferQty}
                                          style={{
                                            borderRadius: "10px",
                                            border: "2px solid red",
                                            width: "150px",
                                          }}
                                          className="text-center form-control"
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(event) =>
                                            handleProAccInputChange(
                                              event,
                                              item.id,
                                              "transferQty",
                                            )
                                          }
                                        />
                                        {item.item_id?.currentQuantity === 0 ? (
                                          <p style={{ color: "red" }}>
                                            Reorder items or Fill only '0'
                                          </p>
                                        ) : item.item_id?.currentQuantity <
                                          item.transferQty ? (
                                          <p style={{ color: "red" }}>
                                            Transfer Qty must have less than
                                            Stock Qty!
                                          </p>
                                        ) : (
                                          <p style={{ color: "red" }}>
                                            Requested Qty must have less than
                                            equal Stock Qty!
                                          </p>
                                        )}
                                      </>
                                    ) : (
                                      <input
                                        type="number"
                                        defaultValue={item.transferQty}
                                        style={{
                                          borderRadius: "10px",
                                          width: "150px",
                                        }}
                                        className="text-center form-control"
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(event) =>
                                          handleProAccInputChange(
                                            event,
                                            item.id,
                                            "transferQty",
                                          )
                                        }
                                      />
                                    )}
                                    {/* {item.transferQty > item.requestedQty ? (
                                      <p style={{ color: 'red' }}>
                                        Requested Qty must have greater than
                                        Transfer Qty!
                                      </p>
                                    ) : (
                                      ''
                                    )} */}
                                  </Td>
                                  <Td>
                                    <input
                                      type="number"
                                      value={
                                        item?.transferQty *
                                        item.item_id?.purchasePrice
                                      }
                                      style={{
                                        borderRadius: "10px",
                                        width: "150px",
                                      }}
                                      className="text-center form-control"
                                      disabled
                                    />
                                  </Td>
                                  <Td>{item.item_id?.unit}</Td>
                                  <Td>
                                    <input
                                      type="date"
                                      style={{ borderRadius: "10px" }}
                                      className="text-center form-control"
                                      onChange={(event) =>
                                        handleProAccInputChange(
                                          event,
                                          item.id,
                                          "expDate",
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td>
                                    <input
                                      type="date"
                                      style={{ borderRadius: "10px" }}
                                      className="text-center form-control"
                                      onChange={(event) =>
                                        handleProAccInputChange(
                                          event,
                                          item.id,
                                          "alertDate",
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td>
                                    <RxCross2
                                      onClick={() => removeProAcc(index)}
                                    />
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    {/* General Items */}
                    <div className="col-12 mt-3">
                      <h5>General Items</h5>
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>

                            <Th>Stock Qty</Th>

                            <Th>Req Qty</Th>
                            <Th>Purchase Price</Th>
                            <Th>Transfer Qty</Th>
                            <Th>Total</Th>
                            <Th>Unit</Th>
                            <Th>Expired Date</Th>
                            <Th>Alert Date</Th>
                          </Tr>
                        </Thead>
                        {isGenItem && (
                          <Tbody>
                            {upGen &&
                              upGen.map((item, index) => (
                                <Tr>
                                  <Td>{++index}</Td>
                                  {item.item_id?.currentQuantity === 0 ? (
                                    <Td>
                                      <b className="text-red">{item.name}</b>
                                    </Td>
                                  ) : (
                                    <Td>{item.name}</Td>
                                  )}
                                  {item.item_id?.currentQuantity === 0 ? (
                                    <Td>
                                      <b className="text-red">
                                        {item.item_id.currentQuantity}
                                      </b>
                                    </Td>
                                  ) : (
                                    <Td>{item.item_id.currentQuantity}</Td>
                                  )}
                                  {/* <Td>{procedure.purchasePrice}</Td> */}
                                  <Td>{item.requestedQty}</Td>
                                  <Td>{item.item_id?.purchasePrice}</Td>

                                  <Td>
                                    {item.transferQty > item.requestedQty ||
                                    item.item_id?.currentQuantity === 0 ||
                                    item.item_id?.currentQuantity <
                                      item.transferQty ? (
                                      <>
                                        <input
                                          type="number"
                                          defaultValue={item.transferQty}
                                          style={{
                                            borderRadius: "10px",
                                            border: "2px solid red",
                                          }}
                                          className="text-center"
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(event) =>
                                            handleGenInputChange(
                                              event,
                                              item.id,
                                              "transferQty",
                                            )
                                          }
                                        />
                                        {item.item_id?.currentQuantity === 0 ? (
                                          <p style={{ color: "red" }}>
                                            Reorder items or Fill only '0'
                                          </p>
                                        ) : item.item_id?.currentQuantity <
                                          item.transferQty ? (
                                          <p style={{ color: "red" }}>
                                            Transfer Qty must have less than
                                            Stock Qty!
                                          </p>
                                        ) : (
                                          <p style={{ color: "red" }}>
                                            Requested Qty must have less than
                                            equal Stock Qty!
                                          </p>
                                        )}
                                      </>
                                    ) : (
                                      <input
                                        type="number"
                                        defaultValue={item.transferQty}
                                        style={{ borderRadius: "10px" }}
                                        className="text-center"
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(event) =>
                                          handleGenInputChange(
                                            event,
                                            item.id,
                                            "transferQty",
                                          )
                                        }
                                      />
                                    )}
                                    {/* {item.transferQty > item.requestedQty ? (
                                      <p style={{ color: 'red' }}>
                                        Requested Qty must have greater than
                                        Transfer Qty!
                                      </p>
                                    ) : (
                                      ''
                                    )} */}
                                  </Td>
                                  <Td>
                                    <input
                                      type="number"
                                      value={
                                        item?.transferQty *
                                        item.item_id?.purchasePrice
                                      }
                                      style={{ borderRadius: "10px" }}
                                      className="text-center"
                                      disabled
                                    />
                                  </Td>
                                  <Td>{item.item_id?.unit}</Td>
                                  <Td>
                                    <input
                                      type="date"
                                      style={{ borderRadius: "10px" }}
                                      className="text-center form-control"
                                      onChange={(event) =>
                                        handleGenInputChange(
                                          event,
                                          item.id,
                                          "expDate",
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td>
                                    <input
                                      type="date"
                                      style={{ borderRadius: "10px" }}
                                      className="text-center form-control"
                                      onChange={(event) =>
                                        handleGenInputChange(
                                          event,
                                          item.id,
                                          "alertDate",
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td>
                                    <RxCross2
                                      onClick={() => removeGen(index)}
                                    />
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>
                    {/* NOTE End Procedure Accessory */}
                  </div>
                </div>
                <Top>
                  <div className="row" style={{ marginLeft: "330px" }}>
                    {/* {console.log(upProData[0].requestedQty, 'pro tran cr btn')} */}

                    <div className=" col-md-4">
                      {upMedData.map((i) => i.item_id.currentQuantity === 0) ||
                      upProData.map((i) => i.item_id.currentQuantity === 0) ||
                      upProAcc.map((i) => i.item_id.currentQuantity === 0) ||
                      upGen.map((i) => i.item_id.currentQuantity === 0) ? (
                        <Button
                          className="btn btn-sm btn-primary"
                          style={{
                            color: "white",
                          }}
                          onClick={submit}
                          // disabled
                        >
                          Submit
                        </Button>
                      ) : medTran || proTran || accTran || genTran ? (
                        medTran >
                          (upMedData[0] ? upMedData[0].requestedQty : "") ||
                        proTran >
                          (upProData[0] ? upProData[0].requestedQty : "") ||
                        genTran > (upGen[0] ? upGen[0].requestedQty : "") ||
                        accTran >
                          (upProAcc[0] ? upProAcc[0].requestedQty : "") ? (
                          <Button
                            className="btn btn-sm btn-success"
                            onClick={create}
                            disabled
                          >
                            Submit
                          </Button>
                        ) : (
                          <Button
                            className="btn btn-sm btn-success"
                            style={{
                              color: "black",
                            }}
                            onClick={create}
                          >
                            Submit
                          </Button>
                        )
                      ) : (
                        <Button
                          className="btn btn-sm btn-success"
                          style={{ color: "black" }}
                          onClick={create}
                        >
                          Submit
                        </Button>
                      )}
                    </div>

                    {/* <div className='col-md-6'>
                      
                        <Button
                         className='btn btn-sm btn-success'
                          style={{  color: 'black' }}
                          onClick={create}
                        >
                          Submit
                        </Button>
                      </div> */}

                    <div className="ml-3 col-md-4">
                      <Link
                        to="stock-req"
                        className="btn btn-sm px-3 py-1 text-white"
                        style={{
                          borderRadius: "10px",
                          marginTop: "1.7em",
                          fontSize: "12px",
                          width: "95px",
                          backgroundColor: "black",
                          height: "32px",
                        }}
                      >
                        Cancel
                      </Link>
                    </div>
                    <div className="col-3">
                      <Link
                        to={"/show-print/" + Id}
                        style={{
                          borderRadius: "13px",
                          marginTop: "1.5em",
                          fontSize: "13px",
                          backgroundColor: "black",

                          width: "80px",
                        }}
                        className="btn btn-sm mb-2 text-white"
                      >
                        Print
                      </Link>
                    </div>
                  </div>
                </Top>
              </div>
            </div>
          </section>
        </div>

    </>
  );
};

export default Create;
